import { getAdminDashboardApi } from "../../helpers/backend_helper";

import {
    setDashboardData,
    loadingDashboard,
    dashboardError,
} from "./reducer";
export const fetchAdminDashboard = () => async (dispatch) => {
    try {
        dispatch(loadingDashboard(true));

        const response = await getAdminDashboardApi();
        dispatch(setDashboardData(response));

    } catch (error) {
        const errorMessage =
            error?.response?.data?.detail || "Something went wrong, please try again.";
        dispatch(dashboardError(errorMessage));
    } finally {
        dispatch(loadingDashboard(false));
    }
};
